var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.incomes),function(income,i){return [_c('income',{attrs:{"income":income},on:{"edit":args => _vm.$emit('edit', args),"delete":args => _vm.$emit('delete', args)}}),(i + 1 < _vm.incomes.length)?_c('v-divider',{staticClass:"my-2"}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }